<template>
    <transition name="modal">
        <b-modal title="Get Started" :size="dual ? 'lg' : 'md'" id="get-started-modal" hide-footer>
                <b-row>
                    <b-col md="6" v-if="currentProject">
                        <h4>Pick Up Where You Left Off</h4>

                        <p>You have a draft project, would you like to continue working on it?</p>
                    </b-col>

                    <b-col :md="dual ? 6 : 12">
                        <h4>Start A New Project</h4>

                        <b-alert variant="danger" v-if="error">{{error}}</b-alert>

                        <p v-if="projects.length > 0">To get started, tell us what your voice over is for.</p>
                        <p v-if="projects.length === 0">We see you don't have any projects yet. To get started, tell us what your voice over is for.</p>

                        <b-form-group>
                            <multiselect 
                                v-model="application" 
                                :allowEmpty="false" 
                                :options="applications" 
                                label="name"
                                selectLabel=""
                                selectedLabel=""
                                deselectLabel=""
                                >
                            </multiselect>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="6" v-if="currentProject" class="text-center">
                        <b-button variant="success" @click="continueProject">Continue</b-button>
                    </b-col>

                    <b-col :md="dual ? 6 : 12" class="text-center">
                        <b-button variant="success" @click="newProject">Get Started</b-button>
                    </b-col>
                </b-row>

        </b-modal>
    </transition>
</template>

<script>      
    import {Multiselect} from 'vue-multiselect'
    import {mapState, mapGetters} from 'vuex'
    export default {
        components: {Multiselect},
        props: {
        },
        data() {
            return {
                application: null,
                error: null
            }
        },

        created () {
            if (this.$route.query.application) {
                this.application = this.applications.find(app => app.slug === this.$route.query.application)
            }
        },
        
        methods: {
            newProject () {
                this.error = null

                if (!this.application) {
                    this.error = 'Please tell us what the voice over is for'
                }

                if (this.application) {
                    this.$store.commit('project/removeCurrent')
                    this.$store.commit('prompt/clear')

                    this.$store.commit('project/setApplication', this.application)

                    this.$router.push({name: 'new'})
                }
            },
            continueProject () {
                this.$router.push({name: 'project_id', params: {id: this.currentProject}})
            }
        },
        computed: {
            ...mapState({
                currentProject: state => state.project.current
            }),
            ...mapGetters({
                applications: 'tag/applications',
                projects: 'project/items'
            }),
            dual () {
                return !!this.currentProject
            }
        },
    }
</script>



// WEBPACK FOOTER //
// prompts/components/modals/GetStartedModal.vue